export default class CustomerGroup5ManagementColumnModel {
	static CustomerGroup5ManagementColumn = [
	  {
		  title: 'Customer group 5',
		  align: 'left',
		  field: 'group5Name'
	  }
	]
}
